import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({

  genealogyHeader: {
    position: 'fixed',
    top: 0,
    zIndex: 1,
    width: "100%",
    paddingTop: 11,
    paddingLeft: 16,
    paddingRight: 16,
    borderBottom: `1px solid ${theme.app.colors.border.light}`,

    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 39px)'
    },
  },

  genealogyHeaderButtonsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  icon: {
    color: "#000",
    fontSize: 20,
    cursor: 'pointer'
  },

  breadcrumbsIcon: {
    color: "#000",
    fontSize: 20
  },

  breadcrumbsText: {
    fontSize: theme.app.typography.body.fontSize,
    fontWeight: 400,
    fontFamily: 'Poppins, sans-serif'
  },

  genealogyHeaderBreadcrumbsContainer: {
    marginTop: 16
  },

}))
